import Text from '@helvetia/components/Text'
import { SizeName } from '@helvetia/components/theme/size'
import * as React from 'react'

import Edit from '../../_components/icons/edit.svg'
import { MainIcon, PencilIcon } from '../icons/icons'
import { EditIconWrapper, ItemWrapper, TextWrapper } from './Summary.styles'

interface Props {
  icon: React.ReactElement<any>
  top?: SizeName
  bottom?: SizeName
  editionDisabled?: boolean
  onEditClick?: () => void
}

const SummaryItem: React.SFC<Props> = ({
  icon,
  onEditClick,
  top,
  bottom,
  editionDisabled,
  children,
}) => {
  return (
    <ItemWrapper marginTop={top} marginBottom={bottom}>
      <MainIcon>{icon}</MainIcon>
      <TextWrapper>
        <Text as="div" color="black" size="s">
          {children}
        </Text>
      </TextWrapper>
      {!editionDisabled && (
        <EditIconWrapper>
          <PencilIcon src={Edit} onClick={onEditClick} />
        </EditIconWrapper>
      )}
    </ItemWrapper>
  )
}
export default SummaryItem
